/* eslint-disable react/display-name, @typescript-eslint/member-ordering */
import * as React from 'react';
import { scrollToElement } from '../../../utils/navigation';
import { getOfferTitle, getSquareInformation } from '../../../utils/offer_helpers';
import { IUnderlineNavigationLink } from '../../underline_navigation';
import { INavigation } from '../navigation';
import {
  trackGoToAuthorClick,
  trackGoToDescriptionClick,
  trackGoToMapClick,
  trackGoToPhotosClick,
  trackGoToServicePlaceOverEvaluationClick,
  trackGoToServicePlaceOverMapClick,
  trackGoToServicePlaceUnderMapClick,
  trackGoToSimilarOffersClick,
  trackGoToValuationClick,
} from '../tracking';
import { IOfferCardNavigationProps, NavigationTab } from '../types';

interface IOfferCardNavigationState {
  isInTransition: boolean;
}

/**
 * Обертка для элемента навигации, которая передает линки, функцию обработки клика по навигации,
 * обработку изменения состояния
 * @param {React.SFC<INavigation>} Navigation
 */
export const offerCardNavigation = (Navigation: React.SFC<INavigation>) => {
  return class extends React.Component<IOfferCardNavigationProps, {}> {
    private transitionTimeout: number;
    private descriptionElement: HTMLElement | null;
    private mapElement: HTMLElement | null;
    private authorElement: HTMLElement | null;
    private photosElement: HTMLElement | null;
    private servicePlaceOverMapElement: HTMLElement | null;
    private servicePlaceUnderMapElement: HTMLElement | null;
    private servicePlaceOverEvaluationElement: HTMLElement | null;
    private valuation: HTMLElement | null;
    private similarOffers: HTMLElement | null;

    public state: IOfferCardNavigationState = {
      isInTransition: false,
    };

    public componentDidMount() {
      this.descriptionElement = document.querySelector('#description') as HTMLElement | null;
      this.mapElement = document.querySelector('#map') as HTMLElement | null;
      this.authorElement = document.querySelector('#author') as HTMLElement | null;
      this.photosElement = document.querySelector('#photos') as HTMLElement | null;
      this.servicePlaceOverMapElement = document.querySelector('#servicePlaceOverMap') as HTMLElement | null;
      this.servicePlaceOverEvaluationElement = document.querySelector(
        '#servicePlaceOverEvaluation',
      ) as HTMLElement | null;
      this.valuation = document.querySelector('#valuation');
      this.servicePlaceUnderMapElement = document.querySelector('#servicePlaceUnderMap') as HTMLElement | null;
      this.similarOffers = document.querySelector('#similarOffers') as HTMLElement | null;
    }

    public UNSAFE_componentWillReceiveProps(nextProps: IOfferCardNavigationProps) {
      if (this.props.isFixed && this.props.isActive !== nextProps.isActive) {
        this.setState(
          {
            isInTransition: true,
          },
          () => {
            // tslint:disable-next-line:strict-type-predicates
            if (typeof this.transitionTimeout !== 'undefined') {
              window.clearTimeout(this.transitionTimeout);
            }

            this.transitionTimeout = window.setTimeout(
              () =>
                this.setState({
                  isInTransition: false,
                }),
              250,
            );
          },
        );
      }
    }

    public render() {
      const { isInTransition } = this.state;
      const { offer, activeAnchor, isFixed, isActive, showRightContent } = this.props;

      return (
        <Navigation
          navigate={this.onNavClick}
          activeHref={activeAnchor as string}
          links={this.getLinks()}
          description={`${offer && getOfferTitle(offer)}, ${offer && getSquareInformation(offer)}`}
          isActive={Boolean(isActive)}
          isInTransition={isInTransition}
          isFixed={Boolean(isFixed)}
          showRightContent={Boolean(showRightContent)}
        />
      );
    }

    private getLinks = (): IUnderlineNavigationLink[] => {
      const { offer, isAgentAvailable, isFixed, isSimilarOffersAvailable } = this.props;

      const photoText = isFixed ? `Фотографии (${(offer && offer.photos && offer.photos.length) || 0})` : 'Фотографии';
      const authorText = isFixed ? 'Контактное лицо' : 'Контакты';

      const links: IUnderlineNavigationLink[] = [];
      links.push({ href: NavigationTab.Photos, text: photoText });
      links.push({ href: NavigationTab.Description, text: 'Описание' });
      if (this.servicePlaceOverMapElement) {
        links.push({ href: NavigationTab.ServicePlaceOverMap, text: 'Ипотека' });
      }
      links.push({ href: NavigationTab.Map, text: 'На карте' });
      if (this.servicePlaceUnderMapElement) {
        links.push({ href: NavigationTab.ServicePlaceUnderMap, text: 'Ипотека' });
      }
      if (this.servicePlaceOverEvaluationElement) {
        links.push({ href: NavigationTab.ServicePlaceOverEvaluation, text: 'Ипотека' });
      }
      if (this.valuation) {
        links.push({ href: NavigationTab.Valuation, text: 'Оценка' });
      }

      if (isAgentAvailable) {
        links.push({ href: NavigationTab.Author, text: authorText });
      }

      if (isSimilarOffersAvailable) {
        links.push({ href: NavigationTab.SimilarOffers, text: 'Похожие объявления' });
      }

      return links;
    };
    private onNavClick = (event: React.MouseEvent<HTMLAnchorElement>, href: string) => {
      switch (href) {
        case NavigationTab.Photos:
          this.handleNavigate(event, this.photosElement);
          trackGoToPhotosClick();
          break;
        case NavigationTab.Description:
          this.handleNavigate(event, this.descriptionElement);
          trackGoToDescriptionClick();
          break;
        case NavigationTab.ServicePlaceOverMap:
          this.handleNavigate(event, this.servicePlaceOverMapElement);
          trackGoToServicePlaceOverMapClick();
          break;
        case NavigationTab.ServicePlaceUnderMap:
          this.handleNavigate(event, this.servicePlaceUnderMapElement);
          trackGoToServicePlaceUnderMapClick();
          break;
        case NavigationTab.ServicePlaceOverEvaluation:
          this.handleNavigate(event, this.servicePlaceOverEvaluationElement);
          trackGoToServicePlaceOverEvaluationClick();
          break;
        case NavigationTab.Map:
          this.handleNavigate(event, this.mapElement);
          trackGoToMapClick();
          break;
        case NavigationTab.Valuation:
          this.handleNavigate(event, this.valuation);
          trackGoToValuationClick();
          break;
        case NavigationTab.SimilarOffers:
          this.handleNavigate(event, this.similarOffers);
          trackGoToSimilarOffersClick();
          break;
        default:
          this.handleNavigate(event, this.authorElement);
          trackGoToAuthorClick();
      }
    };
    private handleNavigate = (event: React.MouseEvent<HTMLAnchorElement>, element: HTMLElement | null) => {
      scrollToElement(element);
    };
  };
};
